<div class="feedback-modal-container">
  <button mat-icon-button class="close-button" (click)="onClose()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <mat-card class="feedback-card">
    <div class="feedback-header">
      <h2>PopStudy Feedback</h2>
      <p>Help us improve your learning experience</p>
    </div>

    <mat-card-content>
      <form class="feedback-form" (ngSubmit)="submitFeedback()" #feedbackForm="ngForm">
        <mat-form-field appearance="outline">
          <mat-label>Your Name</mat-label>
          <input matInput name="name" [(ngModel)]="formData.name" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Your Email</mat-label>
          <input matInput name="email" type="email" [(ngModel)]="formData.email" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Your Feedback</mat-label>
          <textarea matInput name="feedback" [(ngModel)]="formData.feedback" required rows="5"
                    placeholder="What do you like about PopStudy? What can we improve?"></textarea>
        </mat-form-field>

        <div class="button-row">
          <button mat-button class="cancel-button" type="button" (click)="onClose()">Cancel</button>
          <button mat-raised-button class="submit-button" type="submit"
                  [disabled]="isLoading() || !feedbackForm.form.valid">
            <span *ngIf="isLoading()" class="spinner"></span>
            {{ isLoading() ? 'Sending...' : 'Send Feedback' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
